import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }
});
export const figure41 = {
  chart: {
    zoomType: 'xy',
    animation: false,
    marginTop: 50,
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    type: 'bar',
    height: '600px',
    backgroundColor: 'rgba(255, 255, 255, 0.0)',
    style: {
      fontFamily: 'Montserrat'
    }
  },

  colors: ['#5b9bd5'],

  credits: {
    enabled: false
  },
  title: {
    text: null
  },
  subtitle: {
    text: null
  },

  plotOptions: {
    series: {
      borderWidth: 0,
      marker: {
        symbol: 'circle',
        enabled: false,
        states: {
          hover: {
            enabled: true,
            radius: 5
          }
        }
      }
    }
  },

  exporting: {
    enabled: false
  },


  xAxis: [{
    categories: [
		 "Monde",
		 "Asie du Sud-Est",
		 "Asie de l’Est",
		 "Asie de l’Est et Asie du Sud-Est",
		 "Océanie hors Australie et Nouvelle-Zélande",
		 "Australie et Nouvelle-Zélande",
		 "Océanie",
		 "Amérique latine et Caraïbes",
		 "Afrique subsaharienne",
		 "Afrique du Nord",
		 "Asie de l’Ouest",
		 "Asie de l’Ouest et Afrique du Nord",
		 "Europe",
		 "Amérique du Nord",
		 "Amérique du Nord et Europe ",
		 "Asie centrale",
		 "Asie du Sud",
		 "Asie centrale et Asie du Sud",
    ],
    lineColor: "#d7d7d7",
    tickColor: "#d7d7d7",
    tickLength: 16,
    labels: {

      style: {
        fontWeight: 'normal',
        color: '#999999',
        fontSize: '12px'
      }
    },
  }],
  yAxis: [{ // Primary yAxis
    labels: {
      
      style: {
        fontWeight: 'normal',
        color: '#999999',
        fontSize: '12px'
      },
    },
    gridLineWidth: 2,
    max: 140,
    min: 0,
    tickInterval: 20,
    title: {
      text: null,
      style: {
        color: Highcharts.getOptions().colors[1]
      }
    }
  }],
  tooltip: {
    shared: true,
    useHTML: true,
    hideDelay: 500,
    backgroundColor: null,
    borderWidth: 0,
    shadow: false,
    style: {
      padding: 0
    }
  },
  legend: {
    enabled: false,
  },

  series: [{
    name: '',
    tooltip: {
      valueSuffix: '%'
    },
    dataLabels: {
      enabled: true,
      style: {
        fontWeight: 'normal',
        textOutline: false,
        color: '#999999',
        fontSize: '12px'
      }

    },
    data: [
        {y: 18.6, color: '#008024'},
        {y: 20.4, color: '#008024'},
        {y: 45.6, color: '#2ccd50'},
        {y: 31, color: '#2ccd50'},
        {y: 0.2, color: ''},
        {y: 5.4, color: '#008024'},
        {y: 2.9, color: '#008024'},
        {y: 6.8, color: '#008024'},
        {y: 6.1, color: '#008024'},
        {y: 120.5, color: '#ff101a'},
        {y: 69.1, color: '#fefe56'},
        {y: 84.1, color: '#ffbf42'},
        {y: 8.5, color: '#2ccd50'},
        {y: 20.2, color: '#2ccd50'},
        {y: 12.5, color: '#2ccd50'},
        {y: 80.3, color: '#ffbf42'},
        {y: 76.5, color: '#ffbf42'},
        {y: 70.4, color: '#fefe56'},
        
    ]
  }]

}